export { default } from './GroupRegistrationDataPage';
